export default {
  getBillingAddress: (state) => {
    return state.billingAddress
  },
  paymentType: (state) => {
    return state.requirePayment
  },
}
